








import { Component, Vue } from 'vue-property-decorator';
import { EnquiryApi } from '@/api/enquiry-api';
import { Enquiry } from '@/models/enquiry';
import quoteForm from '@/components/quote-form.vue';
import debounce from 'lodash.debounce';

const enquiryApi = new EnquiryApi();

@Component({
    components: {
        quoteForm,
    },
})
export default class CreateQuote extends Vue {
    public isLoading: boolean = true;
    public enquiry: Enquiry | null = null;

    public async mounted(): Promise<void> {
        this.isLoading = true;

        const enquiry = await enquiryApi.fetchByIdAsync(this.$route.params.id);

        this.enquiry = enquiry;
        this.isLoading = false;
    }
    public async handleQuoteSavedInternal(id: string): Promise<void> {
        await this.$router.push({ name: 'view-quote', params: { id: id } });
    }
    public handleQuoteSaved = debounce(this.handleQuoteSavedInternal, 750);
}
